import { Ref, computed, watch } from 'vue';
import { useLayoutStore } from '@/stores/layoutStore';
import { useChartNotesV2 } from '@/composables/useChartNotesV2';
import { useAutoRefresh } from '@/composables/useAutoRefresh';
import { useChartDimensions } from '@/composables/useChartDimensions';
import { useCookies } from '@/composables/useCookies';
import { INSPECTOR_COOKIE_KEY, INSPECTOR_COOKIE_ON_VALUE } from '@/enums/cookies';

let isInspectorDisabled: Ref<boolean> | undefined;

let hasInitialized = false;

// TODO: move inspector code from Chart.vue, App.vue, layoutStore, cookies.js, etc. into this composable

function setIsInspecting(isNowInspecting: boolean) {
  const layoutStore = useLayoutStore();
  const { refreshChart } = useAutoRefresh();
  const { setCookie, removeCookie } = useCookies();

  if (isInspectorDisabled?.value) {
    return;
  }

  if (!isNowInspecting) {
    removeCookie(INSPECTOR_COOKIE_KEY);
  } else {
    setCookie(INSPECTOR_COOKIE_KEY, INSPECTOR_COOKIE_ON_VALUE);
  }

  layoutStore.$patch({ isInspecting: isNowInspecting });

  refreshChart();
}

function handleIsAutoSizeChartsEnabledChanged() {
  const { isAutoSizeChartsEnabled } = useChartDimensions();

  if (!isAutoSizeChartsEnabled.value) {
    return;
  }

  setIsInspecting(false);
}

function init() {
  const { isActivatingAnnotationMode, isAnnotating } = useChartNotesV2();
  const { isAutoSizeChartsEnabled } = useChartDimensions();

  if (hasInitialized) {
    return;
  }

  hasInitialized = true;

  isInspectorDisabled = computed(() => {
    return isActivatingAnnotationMode.value || isAnnotating.value;
  });

  watch(isAutoSizeChartsEnabled, handleIsAutoSizeChartsEnabledChanged);
}

export function useInspector() {
  init();

  return {
    isInspectorDisabled,
    setIsInspecting
  };
}
